(function (win, lib) {
  var doc = win.document
  var docEl = doc.documentElement
  var dpr = window.devicePixelRatio || 1
  var tid
  var flexible = lib.flexible || (lib.flexible = {})
   
  
  function refreshRem () {
    var docWidth = docEl.getBoundingClientRect().width
    var ua = navigator.userAgent
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/)
    var isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/)
    var isAndroid = ua.match(/(Android)\s+([\d.]+)/)
    var isMobile = !!isIphone || !!isAndroid || !!ipad
    if (!isMobile) {
      docWidth = docEl.clientWidth > 640 ? 640 : docEl.clientWidth 
    } 

    var rem = docWidth / 10
    docEl.style.fontSize = rem + 'px'
    flexible.rem = win.rem = rem
  }
  
  win.addEventListener('resize', function () {
    clearTimeout(tid)
    tid = setTimeout(refreshRem, 300)
  }, false)
  win.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      clearTimeout(tid)
      tid = setTimeout(refreshRem, 300)
    }
  }, false)
  
  if (doc.readyState === 'complete') {
    doc.body.style.fontSize = 12 * dpr + 'px'
  } else {
    doc.addEventListener('DOMContentLoaded', function () {
      doc.body.style.fontSize = 12 * dpr + 'px'
    }, false)
  }
  
  
  refreshRem()
  
  flexible.dpr = win.dpr = dpr
  flexible.refreshRem = refreshRem
  window.dpr = dpr
  window.rem2px = flexible.rem2px = function (d) {
    var val = parseFloat(d) * this.rem
    if (typeof d === 'string' && d.match(/rem$/)) {
      val += 'px'
    }
    return val
  }
  window.px2rem = flexible.px2rem = function (d) {
    var maxRem = this.rem * dpr > 75 ? 75 : this.rem * dpr
    var val = parseFloat(d) / maxRem
    if (typeof d === 'string' && d.match(/px$/)) {
      val += 'rem'
    }
    return val
  }
})(window, window['lib'] || (window['lib'] = {}))  